var _a, _b;
const defaultConfig = {
    // The default locale
    locale: 'en-gb',
    // List of supported types
    supportedTypes: [
        'casinogame',
        'helpanswer',
        'match',
        'event',
        'promotion',
        'race',
        'league',
        'selection',
        'sport',
        'static',
    ],
    // URL where all resources are put
    // FIXME: document.currentScript not supported in Internet Explorer.
    searchCdnUrl: ((_b = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.src) === null || _b === void 0 ? void 0 : _b.replace(/\/[^/]+$/, '')) || '',
    // URL for Sportsbook URL
    sportsbookUrl: '',
    // URL for Casino Games launcher
    launcherUrl: '',
    // URL for Advanced Search API
    searchApiUrl: '',
};
export function fulfillConfig() {
    var _a;
    // @ts-ignore: using possible global variable
    if (window.$whSearch && !((_a = window.$whSearch) === null || _a === void 0 ? void 0 : _a.$fulfilled)) {
        // @ts-ignore: ensuring all defaults are included
        window.$whSearch = Object.assign(Object.assign({ $fulfilled: true }, defaultConfig), window.$whSearch);
    }
}
export function getConfig() {
    // Ensure that all default will be included, and the config will not be duplicated
    fulfillConfig();
    // @ts-ignore: using possible global variable
    const config = window.$whSearch || defaultConfig;
    const isPP1 = window.location.hostname.includes('pp1');
    const envConfig = isPP1 ? envConfigs.pp1 : envConfigs.prod;
    return Object.assign(Object.assign({}, config), envConfig);
}
const envConfigs = {
    pp1: {
        sportsbookUrl: 'https://sports.williamhill-pp1.com',
        launcherUrl: 'https://launcher.williamhill-pp1.com',
        searchApiUrl: 'https://search.williamhill-pp1.com/v2/',
    },
    prod: {
        sportsbookUrl: 'https://sports.williamhill.com',
        launcherUrl: 'https://launcher.williamhill.com',
        searchApiUrl: 'https://search.williamhill.com/v2/',
    },
};
export const DEFAULT_FILTER_TAB = { id: 'all', name: 'All', slug: 'all' };
export const CASINOGAME_FILTER_TAB = { id: 'casinogame', name: 'Gaming', slug: 'gaming' };
export const PROMOTION_FILTER_TAB = { id: 'promotion', name: 'Promotions', slug: 'promotions' };
//# sourceMappingURL=config.js.map